module.exports = __webpack_public_path__ + "static/home-hero-aadacec13ae7bae202645fc536c21434.gif";